import _ from 'lodash';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ForwarderService, Staff, Staff2, UserModel, PagerService, AlertService } from '../../../services/index';
import { Util } from '../../../utils/util';
declare var $:any;

@Component({
  selector: 'company-users',
  templateUrl: 'company-users.html'
})


export class CompanyUsersComponent {
  @Input() corpId;
  @Input() officeList;
  @Output() hideEe: EventEmitter<any> = new EventEmitter();



  empList : Array<Staff2> = [];
  notRegEmpList: Array<UserModel2> = new Array();
  filteredNotRegEmpList: Array<UserModel2> = new Array();
  notRegEmpListForDrp;
  officeListForDrp;

  searchText:string = '';

  pager: any = {};
  pagedItems: any[];

  constructor( 
    private forwarderService : ForwarderService,
    private pagerService: PagerService,
    private alertService: AlertService
  ) {}

  ngOnInit() {
    this.initSearch();

    this.makeOfficeListForDrp(this.officeList);
  }
  
	close() {
    this.hideEe.emit();
	}

  clickOutside() {
    this.close();
  }

  initSearch(){
    this.empList = [];
    this.forwarderService.getCorpUsersbyCorpId(this.corpId).subscribe(
      resp => {
        this.empList = resp;
      }
    );

    this.notRegEmpList = [];
    this.filteredNotRegEmpList = [];
    this.forwarderService.getUsersNotCorpUser().subscribe(
      resp => {
        this.notRegEmpList = resp;
        this.filteredNotRegEmpList = this.notRegEmpList;
        this.setPage(1);
      }
    );

    // this.forwarderService.getCompanyUsers(this.corpId).subscribe(
    //   resp => {
    //     if(resp.result) {
    //       this.empList = resp.data.regEmpList;
    //       this.notRegEmpList = resp.data.notRegEmpList;
    //       this.filteredNotRegEmpList = _.filter(this.notRegEmpList, {corporation: null});
    //       this.setPage(1);
    //     } else {
    //       $.sweetModal({
    //         content: resp.errorMsg,
    //         icon: $.sweetModal.ICON_WARNING
    //       });
    //     }
    //   }
    // );
  }
  
  makeOfficeListForDrp(data) {
    this.officeListForDrp = _.map(data, (office, index) => {
      office.value = office.officeId;
      office.label = office.officeNm;
      return office;
    });
  }


  checkAllNotRegUser(isChecked) {    
    if (_.isEmpty(this.pagedItems)) return;
    for(let i = 0 ; i < this.pagedItems.length ; i++) {
      this.pagedItems[i].isChecked = isChecked;
    }
  }

  addEmployee() {

  }

  // cancelEmployee(i:number) {
  //   let that = this;
  //   $.sweetModal.confirm('취소를 진행 하시겠습니까?', function() {
  //     if(that.empList[i].userId != null && that.empList[i].userId != undefined){
  //       that.forwarderService.delEmployeeUser(that.corpId, that.empList[i].userId).subscribe(
  //         resp=>{
  //           if(resp.result) {
  //             $.sweetModal({
  //               content: '취소 되었습니다.',
  //               icon: $.sweetModal.ICON_SUCCESS,
  //             })
  //           } else {
  //             $.sweetModal({
  //               content: resp.errorMsg,
  //               icon: $.sweetModal.ICON_WARNING
  //             })
  //           }
  //         }
  //       );
  //     }
  //     that.empList.splice(i, 1);
  //   }, function(){});
  // }

  updateEmployeeStusCd(i:number, stusCd:number){
    let that = this;
    let msg = '승인을';
    if(stusCd == 2) msg = '취소를';
    let emp = _.cloneDeep(that.empList[i]);
    let copyStusCd = emp.stusCd;
    emp.stusCd = stusCd;

    $.sweetModal.confirm(msg + ' 진행 하시겠습니까?', function() {
      if (stusCd == 1) {
        that.forwarderService.postEmployeeList([that.empList[i].email], that.corpId).subscribe(
          resp=>{
            that.alertService.success('상태 변경이 완료되었습니다.');
            that.initSearch();            
          }
        );
      } else if(stusCd == 2){
        that.forwarderService.deleteFwdrEmployee(that.corpId, that.empList[i].email).subscribe(
          resp=>{
            that.alertService.success('상태 변경이 완료되었습니다.');
            that.initSearch();            
          }
        );
      }
    }, function(){
      emp.stusCd = copyStusCd;
    });
  }


  onChangeInput(index, fieldNm, value) {
    this.empList[index][fieldNm] = value;
  }

  onChangeInputNotRegUser(index, fieldNm, value) {
    this.pagedItems[index][fieldNm] = value;
  }

  setPage(page: number) {
    this.pager = this.pagerService.getPager(this.filteredNotRegEmpList.length, page, 10);

    // if (page < 1) {
    //   return;
    // } 

    this.pagedItems = this.filteredNotRegEmpList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }
  
  postEmployee() {
    // emails
    let empListForSave = [];

    for(var i = 0; i < this.empList.length; i++) {
      if (!this.empList[i].status) {
        empListForSave.push(this.empList[i].email);
      }      
    }

    this.forwarderService.postEmployeeList(empListForSave, this.corpId).subscribe(
      resp => {
        $.sweetModal({
          content: '저장되었습니다.',
          icon: $.sweetModal.ICON_SUCCESS,
          closeOnClickOutside: false
        });
        this.initSearch();        
      }
    )
  }

  addToMyEmplList() {
    for(let i = 0 ; i < this.pagedItems.length ; i++) {
      var notRegUser = this.pagedItems[i];
      if(notRegUser.isChecked) {
        var userId = _.find(this.empList, {userId : notRegUser.userId});
        if(userId != null) continue;

        var empl = new Staff2();
        
        empl.email = notRegUser.email;
        empl.tel = notRegUser.mobile;
        empl.userId = notRegUser.userId;
        empl.name = notRegUser.lastNm+notRegUser.firstNm;
        
        this.empList.push(empl);
      }
    }
  }

  search(event) {
    var filterValue = event.target.value;

    this.filteredNotRegEmpList = _.filter(this.notRegEmpList, item => {
			if (!filterValue) return true;

      let valuesStr = Util.getString(item);
      const filter = filterValue.toLocaleLowerCase().replace(/\s/gi, "");
			return valuesStr.indexOf(filter) >= 0;
    });
    
    this.setPage(1);
  }

  deleteEmployee(i:number){
    this.empList.splice(i, 1);
  }

}

export class UserModel2 extends UserModel {
  isChecked:boolean;
}


// WEBPACK FOOTER //
// ./src/app/containers/fwdr/detail/company-users.ts